import script from "./SelectorOption.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelectorOption.vue?vue&type=script&setup=true&lang=ts"

import "./SelectorOption.vue?vue&type=style&index=0&id=39e87e32&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39e87e32"]])

export default __exports__